(function () {
  /**
   * @ngdoc module
   * @name app.widgets.common.go-url
   * @description module that defines go-url widgets
   */
  angular.module('app.widgets.common.go-url', ['binky.core.locale']);
})();
